import { useEffect, useState } from "react";

export default function usePagination<T>(items: T[], page: number, setFirstPage: () => void, pageSize: number = 10): [number, T[]] {
    const [pageCount, setPageCount] = useState(getPageCount(items.length, pageSize));
    const [pagedItems, setPagedItems] = useState(getPagedItems(items, page, pageSize));

    useEffect(() => {
        return setFirstPage;
    }, [items, pageSize]);

    useEffect(() => {
        setPageCount(getPageCount(items.length, pageSize));
        setPagedItems(getPagedItems(items, page, pageSize));
    }, [items, page, pageSize]);

    return [
        pageCount,
        pagedItems,
    ];
}

const getPageCount = (itemsLength: number, pageSize: number) => Math.ceil(itemsLength / pageSize);
const getPagedItems = <T>(items: T[], page: number, pageSize: number) => items.slice((page - 1) * pageSize, page * pageSize);